export default "__VITE_ASSET__DWtzcxsX__"